import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    SUBMIT_INDIVIDUAL_APPLICATION,
    submitIndividualApplicationSuccessful,
    FETCH_INDIVIDUAL_APPLICATION,
    fetchIndividualApplicationReceived,
    UPDATE_INDIVIDUAL_APPLICATION,
    individualApplicantUpdated,
    startLoading,
    stopLoading,
    FETCH_INDIVIDUAL_APPLICATION_REPORT,
    fetchIndividualApplicationReportReceived,
    hasPosted,
    DELETE_APPLICATION,
    hasDeletedApplication,
    VALIDATE_MEMBERSHIP_NUMBER,
    validatedMembershipNumber,
    FETCH_CLASS_DETAILS,
    classDetailsReceived,
    FETCH_CLASS_NOTES_DETAILS,
    classNotesDetailsReceived,
    hasFetchedCountries,
    FETCH_COUNTRIES
} from '../actions'

import {SUBMIT_APPLICATION_ID,
        FETCH_INDIVIDUAL_APPLICATION_ID} from '../store/loaders'


function * submitIndividualApplication (paylaod){
    yield put(startLoading({id:SUBMIT_APPLICATION_ID}))
    try{
       const response=  yield call(DCore.post, '/applications/individuals',{...paylaod.data.data})
        yield put(stopLoading({id:SUBMIT_APPLICATION_ID}))
        yield put (submitIndividualApplicationSuccessful(response.data))
        yield put(individualApplicantUpdated(paylaod.data.reqId))
        yield put(hasPosted(paylaod.data.id))

    }catch(e){
        yield put(stopLoading({id:SUBMIT_APPLICATION_ID}))
        yield put(individualApplicantUpdated(e.response))
        console.log("error",e)
    }
}

function * updateIndividualApplication (paylaod){
    yield put(startLoading({id:SUBMIT_APPLICATION_ID}))
    try{
        const response = yield call(DCore.put, `/applications/individuals/${paylaod.data.id}`,{...paylaod.data.data})
        yield put(stopLoading({id:SUBMIT_APPLICATION_ID}))
        yield put (submitIndividualApplicationSuccessful(response.data))
        yield put(individualApplicantUpdated(paylaod.data.reqId))

    }catch(e){
        yield put(stopLoading({id:SUBMIT_APPLICATION_ID}))
        yield put(individualApplicantUpdated(e.response))
        console.log(e.response)
    }
}

function * fetchIndividualApllication (payload){
    yield put(startLoading({id:FETCH_INDIVIDUAL_APPLICATION_ID}))
    try{
        const response = yield call(DCore.get, `/applications/${payload.data}/individual`, true)
        yield put(stopLoading({id:FETCH_INDIVIDUAL_APPLICATION_ID}))
        yield put(fetchIndividualApplicationReceived(response.data))

    }catch(e){
        yield put(stopLoading({id:FETCH_INDIVIDUAL_APPLICATION_ID}))
        console.log(e.response)
    }
}


function * fetchIndividualApplicationReport (payload){
    yield put(startLoading({id:FETCH_INDIVIDUAL_APPLICATION_ID}))
    try{
        const response = yield call(DCore.get, `/applications/${payload.data}/individuals`, true)
        yield put(stopLoading({id:FETCH_INDIVIDUAL_APPLICATION_ID}))
        yield put(fetchIndividualApplicationReportReceived(response.data))

    }catch(e){
        yield put(stopLoading({id:FETCH_INDIVIDUAL_APPLICATION_ID}))
        console.log(e.response)
    }
}

function * deleteApplication (payload){
    try{
        const response = yield call(DCore.destroy, `/applications/${payload.data}`)
        yield put(hasDeletedApplication(response.data))

    }catch(e){
        console.log(e.response)
    }
} 

function * validateMembershipNumber (payload){
    try{
        const response = yield call(DCore.get, `/members/memberships/check?registrationNumber=${payload.data.value}`)
        yield put(validatedMembershipNumber({
            data: response.data,
            status:response.status,
            id:payload.data.id
        }))

    }catch(e){
        console.log(e.response)
    }
} 


function * fetchClassDetails (payload){
    try{
        const response = yield call(DCore.get, `/membershipclasses/${payload.data}/requirements`)
        yield put(classDetailsReceived({
            data: response.data,
        }))

    }catch(e){
        console.log(e.response)
    }
}

function * fetchClassNotesDetails (payload){
    try{
        const response = yield call(DCore.get, `/membershipclasses/${payload.data}/notes`)
        yield put(classNotesDetailsReceived({
            data: response.data,
        }))
    }catch(e){
        console.log(e.response)
    }
}

function * fetchCountries (){
    try{
        const response = yield call(DCore.get, `/members/memberships/countries`)
        yield put(hasFetchedCountries({
            data: response.data,
        }))
    }catch(e){
        console.log(e.response)
    }
}

export function * submitIndividualApplicationSaga(){
    yield takeLatest(SUBMIT_INDIVIDUAL_APPLICATION, submitIndividualApplication)
    yield takeLatest(FETCH_INDIVIDUAL_APPLICATION, fetchIndividualApllication)
    yield takeLatest(UPDATE_INDIVIDUAL_APPLICATION,updateIndividualApplication)
    yield takeLatest(FETCH_INDIVIDUAL_APPLICATION_REPORT,fetchIndividualApplicationReport)
    yield takeLatest(DELETE_APPLICATION,deleteApplication)
    yield takeLatest(VALIDATE_MEMBERSHIP_NUMBER,validateMembershipNumber)
    yield takeLatest(FETCH_CLASS_DETAILS,fetchClassDetails)
    yield takeLatest(FETCH_CLASS_NOTES_DETAILS,fetchClassNotesDetails)
    yield takeLatest(FETCH_COUNTRIES,fetchCountries)

}